<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <select v-model="selected">
          <option
            v-for="(option,index) in options"
            :key="index"
            :value="option.id"
          >{{ option.title }}</option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6" v-for="(result,index) in selectedOptions" :key="index">
        <div>
          <div class="card-divider">
            <h2 v-html="result.title.rendered"></h2>
          </div>
          <div class="card-section">
            <p v-html="result.content.rendered"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      options: [],
      results: [],
      selected: ""
    };
  },
  mounted() {
    fetch("/wp-json/wp/v2/posts/")
      .then(el => el.json())
      .then(result => {
        this.results = result;
        this.getPostsTitle(result);
      });
  },
  computed: {
    selectedOptions: function() {
      if (this.selected === "") {
        return this.results;
      }
      return this.results.filter(element => element.id === this.selected);
    }
  },
  methods: {
    getPostsTitle(posts) {
      this.options = posts.map(element => {
        return {
          title: element.title.rendered,
          id: element.id
        };
      });
    }
  }
};
</script>
